/*
 * @Author: zuoxuecheng
 * @Date: 2024-07-09 09:34:38
 * @Description: 公共函数
 */
import Vue from "vue";
import store from "@/store";
import { getListSetting } from "../api/network/printer";
import CryptoJS from "crypto-js";
let vm = Vue.prototype;
// 格式化时间
function formatterTime(time) {
  if (!time) {
    return "";
  }
  var date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = date.getDate() + " ";
  var h =
    (date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()) +
    ":";
  var s = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
  return Y + M + D + h + m + s;
}
//  格式化时间
function formatterTimeStr(time, str) {
  if (
    (time,
    str == "" && time,
    str == null && time,
    str == undefined || time == 0)
  ) {
    return "";
  }
  var date = undefined;
  if ((time + "").length == 10) {
    date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  } else {
    date = new Date(time);
  }
  const yyyy = date.getFullYear();
  const MM =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  const dd = date.getDate();
  const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const m =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const s =
    date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
  const dateData = { yyyy, MM, dd, h, m, s };
  for (let key in dateData) {
    if (str.indexOf(key) != -1) {
      str = str.replace(key, dateData[key]);
    }
  }
  return str;
}

export function md5Name(name) {
  let leng = name.length;
  let index = name.lastIndexOf(".");
  let prefixName = name.substring(0, index);
  let suffixName = name.substring(index + 1, leng);
  return vm.$md5(prefixName) + "." + suffixName;
}

export function formatterStatus(device_status, is_printing) {
  let status = "";
  if (device_status == "1" && is_printing == "1") {
    status = "Free";
  } else if (device_status == "1" && is_printing == "2") {
    status = "Busy";
  } else if (device_status == "2") {
    status = "Offline";
  }
  return status;
}

//  秒数转化为时分秒
export function formatSeconds(value) {
  if (value == 0) {
    return "0min";
  }
  //  秒
  let second = parseInt(value);
  //  分
  let minute = 0;
  //  小时
  let hour = 0;
  //  天
  //  let day = 0
  //  如果秒数大于60，将秒数转换成整数
  if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
    minute = parseInt(second / 60);
    //  获取秒数，秒数取佘，得到整数秒数
    second = parseInt(second % 60);
    //  如果分钟大于60，将分钟转换成小时
    if (minute > 60) {
      //  获取小时，获取分钟除以60，得到整数小时
      hour = parseInt(minute / 60);
      //  获取小时后取佘的分，获取分钟除以60取佘的分
      minute = parseInt(minute % 60);
      //  如果小时大于24，将小时转换成天
      //  if (hour > 23) {
      //    //  获取天数，获取小时除以24，得到整天数
      //    day = parseInt(hour / 24)
      //    //  获取天数后取余的小时，获取小时除以24取余的小时
      //    hour = parseInt(hour % 24)
      //  }
    }
  }

  // let result = '' + parseInt(second) + '秒'
  let result = "";
  if (hour > 0) {
    result = result + parseInt(hour) + "h";
    if (second >= 30) {
      result = result + (parseInt(minute) + 1) + "min";
    } else {
      result = result + parseInt(minute) + "min";
    }
  } else {
    if (second >= 30) {
      result = result + (parseInt(minute) + 1) + "min";
    } else {
      result = result + parseInt(minute) + "min";
    }
  }
  //  if (day > 0) {
  //    result = '' + parseInt(day) + '天' + result
  //  }
  // console.log('result：', result)
  return result;
}

export function px(list) {
  let result = [];
  let busyArr = list.filter((item) => {
    return item.device_status == "1" && item.is_printing == "2";
  });
  let freeArr = list.filter((item) => {
    return item.device_status == "1" && item.is_printing == "1";
  });
  let offlineArr = list.filter((item) => {
    return item.device_status == "2";
  });
  if (busyArr && busyArr.length > 0) {
    let haveBox = busyArr.filter(
      (i) => i.multi_color_box && Object.keys(i.multi_color_box).length > 0
    );
    let noBox = busyArr.filter((i) => !i.multi_color_box);
    result = result.concat(haveBox, noBox);
  }
  if (freeArr && freeArr.length > 0) {
    let haveBox = freeArr.filter(
      (i) => i.multi_color_box && Object.keys(i.multi_color_box).length > 0
    );
    let noBox = freeArr.filter((i) => !i.multi_color_box);
    result = result.concat(haveBox, noBox);
  }
  if (offlineArr && offlineArr.length > 0) {
    let haveBox = offlineArr.filter(
      (i) => i.multi_color_box && Object.keys(i.multi_color_box).length > 0
    );
    let noBox = offlineArr.filter((i) => !i.multi_color_box);
    result = result.concat(haveBox, noBox);
  }
  return result;
}

export function getQueryParam(url, key) {
  if (!url || !key) return null;
  const queryString = url.split("?")[1]; // 去掉开头的问号 "?"
  if (!queryString) return null;

  const queryParams = queryString.split("&");

  for (let i = 0; i < queryParams.length; i++) {
    const pair = queryParams[i].split("=");
    if (decodeURIComponent(pair[0]) === key) {
      return decodeURIComponent(pair[1] || "");
    }
  }

  return null;
}

//  判断消息与当前打印机唯一性
export function getIsTips() {
  const {
    printer_type,
    cur_before_task: { topic },
    cur_printer,
    lan_mqtt,
  } = store.state.printer;
  const http_key = cur_printer?.key;
  const mqtt_key = lan_mqtt?.deviceId;
  return printer_type === "cloud"
    ? topic?.indexOf(http_key) != -1
    : topic?.indexOf(mqtt_key) != -1;
}

//  判断当前打印机是在mac打开还是window打开
export function getSliceType () {
  const str = navigator.platform;
  let faild = "";
  if (str.indexOf("Mac") === 0) {
    faild = "mac";
  } else if (str.indexOf("Win") === 0) {
    faild = "win";
  } else {
    faild = "";
  }
  return faild;
}

//  判断ipv4 格式是否正确
export function isValidIPv4 (ip) {
  const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return ipv4Regex.test(ip);
}

export function formmatImg(model) {
  let map = {
    k2max: require("../assets/imgs/printers/Kobra2_Max_thumbnail.png"),
    k2plus: require("../assets/imgs/printers/Kobra2_Plus_thumbnail.png"),
    k2pro: require("../assets/imgs/printers/Kobra2_Pro_thumbnail.png"),
    k3: require("../assets/imgs/printers/Kobra3_thumbnail.png"),
    s1: require("../assets/imgs/printers/Kobra_s1.png"),
    k3max: require("../assets/imgs/printers/Kobra3_thumbnail.png"),
  };
  let src = "";
  if (model.toLowerCase().includes("anycubic kobra 2 max")) {
    src = map.k2max;
  } else if (model.toLowerCase().includes("anycubic kobra 2 plus")) {
    src = map.k2plus;
  } else if (model.toLowerCase().includes("anycubic kobra 2 pro")) {
    src = map.k2pro;
  } else if (model.toLowerCase().includes("anycubic kobra 3")) {
    src = map.k3;
  } else if (model.toLowerCase().includes("anycubic kobra s1")) {
    src = map.s1;
  } else if (model.toLowerCase().includes("anycubic kobra 3 max")) {
    src = map.k3max;
  }
  return src;
}

export function getSetting() {
  getListSetting({ type: "FDM" }).then((res) => {
    if (res.code == 1) {
      store.commit("SET_SETTING_LIST", res.data);
    }
  });
}

export function replaceSeat(str, val) {
  return str.replace("%&#%", val);
}

export function decryptText(data, key, iv) {
  const decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

export function generateSecureRandomString(length) {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const randomValues = new Uint8Array(length);
  window.crypto.getRandomValues(randomValues);
  return Array.from(
    randomValues,
    (byte) => charset[byte % charset.length]
  ).join("");
}

/**
 * 函数防抖 是n秒后延迟执行，防止按钮重复点击
 * @param {Function} fn 是我们需要包装的事件回调
 * @param {Number} delay 是每次推迟执行的等待时间
 * @returns
 */
export function debounce(fn, delay) {
  // 记录上一次触发的时间
  var timer = null;
  console.log("timer", timer);
  return function (...args) {
    // 保留调用时的this上下文
    var context = this;
    // 每次事件被触发时，都去清除上一次延时器
    if (timer) clearTimeout(timer);
    // 设立新的定时器
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

// 节流函数
export function throttle(fn, delay) {
  let timeout; // 定义一个计时器变量，用于限制函数调用频率
  return function (...args) {
    // 返回一个包装后的函数
    const context = this; // 保存函数执行上下文对象
    if (!timeout) {
      // 如果计时器不存在
      fn.apply(context, args); // 执行函数
      timeout = setTimeout(() => {
        timeout = null; // 清空计时器变量
      }, delay); // 创建计时器，在指定时间后重置计时器变量
    }
  };
}

//  跳转到对应的打印机详情页面
export function jumpSliceInfo (type, key) {
  const curPrinter = store.getters['GET_CUR_PRINTER']
  if (key === curPrinter?.key) return
  if (type == "lan") {
    connectedLan(key)
  } else if (type == "cloud") {
    connectedCloud(key)
  }
}

function connectedCloud (key) {
  const cloudList = store.getters['GET_CLOUD_PRINTER_LIST']
  const cloudIndex = cloudList.findIndex(item => item.key == key)
  if (cloudIndex == -1) return
  const id = cloudList[cloudIndex]['id']

  store.commit("SET_CLOUD_IS_SELECT_ID", String(id));
  store.commit("SET_PRINTER_TYPE", "cloud");
  store.commit("SET_LAN_MQTT", null);
  router.app["_route"].path != "/workbench" &&
    router.app["_router"].push("/workbench");
}

function connectedLan (key) {
  const lanList = store.getters['GET_LAN_PRINTER_LIST']
  const lanIndex = lanList.findIndex(item => item.deviceId == key)
  if (lanIndex == -1) return
  const obj = lanList[lanIndex]
  store.commit("SET_LAN_MQTT", obj);
  store.commit("SET_PRINTER_TYPE", "lan");
  store.commit("SET_CLOUD_IS_SELECT_ID", "");
  router.app["_route"].path != "/workbench" &&
    router.app["_router"].push("/workbench");
}

export function rgbToHex (r, g, b) {
  // 将每个颜色分量转换为16进制，并且确保是两位数
  const toHex = (n) => n.toString(16).padStart(2, '0');

  // 拼接成16进制颜色字符串
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
export function rgbaToHex (r, g, b, a) {
  const toHex = (n) => {
    // 约束分量在 0-255 范围，并转换为两位十六进制
    const clamped = Math.round(Math.min(255, Math.max(0, n)));
    return clamped.toString(16).padStart(2, '0');
  };

  // 直接约束 Alpha 到 0-255，无需转换百分比
  const alphaHex = toHex(a); // 复用 toHex 处理 Alpha

  // 拼接为 #RRGGBBAA 格式
  return `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`;
}

export default {
  rgbToHex,
  rgbaToHex,
  formatterTime,
  md5Name,
  formatterTimeStr,
  formatterStatus,
  formatSeconds,
  px,
  getQueryParam,
  getIsTips,
  getSliceType,
  formmatImg,
  getSetting,
  replaceSeat,
  generateSecureRandomString,
  debounce,
  throttle,
  isValidIPv4,
  jumpSliceInfo
};
